import { PageRoot } from "./PageRoot";
import { PageTab } from "./PageTab";

const Page = Object.assign(PageRoot, {
  Tab: PageTab,
});

export { Page };
